function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { compose, getContext, setDisplayName } from 'recompose';
import TextTruncate from "../TextTruncate";
import { H4, Label, View } from "../Typography";
import { color } from "../../../styles/theme";
export var CARD_TEXT_TYPE = {
  LABEL: 'label',
  SUBTITLE: 'subtitle',
  TITLE: 'title'
};
var CONFIG = {
  tag: {
    label: Label,
    subtitle: View,
    title: H4
  },
  darkTheme: {
    label: color.secondaryTextThemeDark,
    subtitle: color.secondaryTextThemeDark,
    title: color.primaryTextThemeDark
  }
};
var styles = {
  cardLabel: {
    color: color.secondaryText
  },
  cardSubtitle: {
    color: color.secondaryText
  },
  cardTitle: {
    color: color.primaryText
  }
};
var textStyles = {
  label: styles.cardLabel,
  subtitle: styles.cardSubtitle,
  title: styles.cardTitle
};
function getDarkThemeStyle(type) {
  return {
    color: CONFIG.darkTheme[type]
  };
}
function CardText(_ref) {
  var htmlAttributes = _ref.htmlAttributes,
    isThemeDark = _ref.isThemeDark,
    maxLines = _ref.maxLines,
    rootClassName = _ref.rootClassName,
    shouldTruncate = _ref.shouldTruncate,
    style = _ref.style,
    text = _ref.text,
    type = _ref.type,
    shouldRenderDiv = _ref.shouldRenderDiv;
  var Tag = CONFIG.tag[type];
  var darkThemeStyle = isThemeDark ? getDarkThemeStyle(type) : {};
  var mergedStyles = _objectSpread(_objectSpread(_objectSpread({}, textStyles[type]), darkThemeStyle), style);
  var shouldTruncateText = shouldTruncate && typeof text === 'string';
  var elementTag = shouldRenderDiv && 'div';
  return /*#__PURE__*/React.createElement(Tag, _extends({
    rootClassName: rootClassName,
    style: mergedStyles,
    tag: elementTag
  }, htmlAttributes), shouldTruncateText && /*#__PURE__*/React.createElement(TextTruncate, {
    line: maxLines,
    text: text
  }), !shouldTruncateText && text);
}
CardText.defaultProps = {
  type: CARD_TEXT_TYPE.LABEL,
  maxLines: 3
};
export default compose(setDisplayName('CardTextHOC'), getContext({
  isThemeDark: PropTypes.bool
}))(CardText);